import { render, staticRenderFns } from "./CompanyIntr.vue?vue&type=template&id=03fe2eba&scoped=true&"
import script from "./CompanyIntr.vue?vue&type=script&lang=js&"
export * from "./CompanyIntr.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIntr.vue?vue&type=style&index=0&id=03fe2eba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fe2eba",
  null
  
)

export default component.exports